module.exports = __webpack_public_path__ + "static/img/cancel-job.7d40b0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/cancel-job.svg
// module id = PAAE
// module chunks = 46